export const createPagination = (dataTable, paramsTable) => dataTable.map((item, i) => ({ ...item, no: i + 1 + paramsTable.row * (paramsTable.page - 1) }))